import { motion } from "framer-motion";
import api from "@/lib/api";
import { Trophy } from "@phosphor-icons/react";
import { btnPrimary } from "./shared";

const COLORS = ["#38bdf8", "#0ea5e9", "#facc15", "#22d3ee", "#ffffff", "#f472b6"];

export function ShareCelebration({ shares, onDone }) {
  const close = async () => {
    await api.post("/market/celebrated").catch(() => {});
    onDone();
  };
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-sky-950/60 backdrop-blur-sm p-6" data-testid="share-celebration">
      {Array.from({ length: 40 }).map((_, i) => (
        <motion.span key={i} className="absolute top-0 w-2 h-3 rounded-sm"
          style={{ left: `${(i * 37) % 100}%`, background: COLORS[i % COLORS.length] }}
          initial={{ y: -40, rotate: 0, opacity: 1 }}
          animate={{ y: "105vh", rotate: 540, opacity: 0.8 }}
          transition={{ duration: 2.4 + (i % 5) * 0.4, delay: (i % 8) * 0.12, repeat: Infinity }} />
      ))}
      <motion.div initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 200, damping: 14 }}
        className="relative rounded-3xl bg-gradient-to-br from-sky-400 to-cyan-300 text-white p-8 text-center max-w-sm w-full shadow-2xl">
        <Trophy size={56} weight="fill" className="mx-auto text-yellow-300 drop-shadow" />
        <p className="text-xs font-bold uppercase tracking-[0.3em] mt-4 text-white/85">New reward share!</p>
        <p className="font-heading text-7xl font-black leading-none mt-2" data-testid="share-celebration-count">{shares}</p>
        <p className="mt-2 text-white/90">You now hold {shares} reward share{shares > 1 ? "s" : ""}. Keep spending to earn more.</p>
        <button data-testid="share-celebration-close" className={`${btnPrimary} mt-6 bg-white text-sky-700 hover:bg-sky-50`} onClick={close}>Awesome!</button>
      </motion.div>
    </div>
  );
}
